import { makeAutoObservable } from 'mobx';
import {Dependent} from 'main/stores/benefits';
import {DomainStore} from 'shared/store';
import {endpoints, types} from 'main/tools';

class DependantFieldsState {
  store = new DomainStore();

  benefitInfo;
  errors;
  company;

  constructor() {
    makeAutoObservable(this, {
      store: false
    });
  }

  receiveProps({benefitInfo, errors}) {
    this.benefitInfo = benefitInfo;
    this.errors = errors || {};
  }

  async load() {
    await this.store._compose([
      endpoints.CURRENT_COMPANY
    ]);

    this.company = this.store._getSingle(types.COMPANY);
  }

  addNewDependent() {
    this.benefitInfo.dependents.push(new Dependent());
  }

  removeDependent(dependent) {
    this.benefitInfo.dependents.remove(dependent);
  }

  get hasDependents() {
    return !!this.benefitInfo.dependents.length;
  }
}

export default DependantFieldsState;
